type TModal = {
  id: string
  props: any
}
type TStore = {
  currentModal: TModal | null
  onModalUpdate: any
}
export const ModalStore: TStore = {
  currentModal: null,
  onModalUpdate: () => null,
}
function injectProps(props: any = {}) {
  let temporal = {
    onClose: props.onClose,
  }
  props.onClose = function () {
    closeModal()
    if (temporal.onClose) {
      temporal.onClose(...arguments)
    }
  }
  return props
}
export function closeModal() {
  ModalStore.currentModal = null
  ModalStore.onModalUpdate()
}
export function callModal(modalId: string | null, props: any = {}) {
  if (modalId === null) {
    ModalStore.currentModal = null
  } else {
    ModalStore.currentModal = { id: modalId, props: injectProps(props) }
  }
  ModalStore.onModalUpdate()
  return () => {
    if (ModalStore.currentModal !== modalId) {
      return
    }
    closeModal()
  }
}
export const showModal = callModal
